<template>
  <div class="index container">
    <div class="card" v-for="smoothie in smoothies" :key="smoothie.id">
      <div class="card-content">
        <i class="material-icons delete" @click="deleteSmoothie(smoothie.id)">delete</i>
        <h2 class="indigo-text">{{ smoothie.title }}</h2>
        <ul class="ingredients">
          <li v-for="(ing, index) in smoothie.ingredients" :key="index">
            <span class="chip"> {{ ing }} </span>
          </li>
        </ul>
      </div>
      <span class="pink halfway-fab btn-floating btn-large">
        <router-link :to="{ name: 'EditSmoothie', params: { smoothie_slug: smoothie.slug } }">
          <i class="material-icons edit">edit</i>
        </router-link>
      </span>
    </div>   
  </div>
</template>

<script>
import db from '@/firebase/init'
export default {
  name: 'Index',
  data () {
    return {
      smoothies: []
    }
  },
  methods: {
    deleteSmoothie(id) {
      db.collection('smoothies').doc(id).delete()
      .then(() => {
        this.smoothies = this.smoothies.filter(smoothie => {
          return smoothie.id != id
        })
      })
    }
  },
  created() {
    db.collection('smoothies').get()
    .then(snapshot => {
      snapshot.forEach(doc => {
        let smoothie = doc.data()
        smoothie.id = doc.id
        this.smoothies.push(smoothie)
      });
    })
  }
}
</script>


<style>

  .index {

    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 3%;
    margin-top: 7%;

  }

  .index h2 {

    font-size: 1.8em;
    text-align: center;
    margin-top: 0;

  }

  .index .ingredients {

    margin: 2% auto;

  }

  .index .ingredients li {

    display: inline-block

  }

  .index .delete {

    position: absolute;
    top: 4px;
    left: 90%;
    color: #aaa;
    font-size: 1.4em;
    cursor: pointer;

  }

  @media screen and (max-width: 768px) {
    
    .index {
      grid-template-columns: 1fr 1fr;
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/Index.vue